import axios from 'axios'

const SET_CONTINUOUS_STATIONS = 'SET_CONTINUOUS_STATIONS'
const SET_CONTINUOUS_TIMESERIES = 'SET_CONTINUOUS_TIMESERIES'
const SET_IMPORTER_CONFIGS = 'SET_IMPORTER_CONFIGS'
const SET_IMPORTER_CONFIG_Detail = 'SET_IMPORTER_CONFIG_Detail'
const ADD_IMPORTER_CONFIG = 'ADD_IMPORTER_CONFIG'
const UPDATE_IMPORTER_CONFIG = 'UPDATE_IMPORTER_CONFIG'
const SET_IMPORTER_LOGS = 'SET_IMPORTER_LOGS'
const DELETE_IMPORTER = 'DELETE_IMPORTER'

const BASE_URL_getStations = 'api/AdminContinuousImporter/Stations'
const BASE_URL_getTimeSeries = 'api/AdminContinuousImporter/TimeSeries'
const BASE_URL_Importer = 'api/AdminContinuousImporter/Importer'
const BASE_URL_getImporterList = 'api/AdminContinuousImporter/Importers'
const BASE_URL_getImporterLogs = 'api/Logs/ImporterConfig'
const BASE_URL_delteImporterConfig = 'api/AdminContinuousImporter/Importer/'

const AQUARIUS_SERVER_NG = 'AquariusNG'

const IMPORTER_TYPE_GOES = 'Goes'
const IMPORTER_TYPE_SIMPLE_SUTRON = 'Simple_Sutron'
const IMPORTER_TYPE_JDS = 'JDS'
const IMPORTER_TYPE_Optimum = 'Optimum'

const dataSetStationNameRegex = /@(.+)$/
const extractStationNameFromDatasetName = (dataSetName) => {
  const matches = dataSetName.match(dataSetStationNameRegex)
  if (matches && matches.length > 0) {
    // first item includes "@", which we don't want
    return matches.slice(1)
  }
  return []
}

function initialState() {
  return {
    Stations: [],
    TimeSeries: [],
    ImporterConfigs: [],
    ImporterConfigDetail: {},
    ImportersLogs: [],
    NGTimeSeriesReady: false,
    NGTimeSeriesList: [],
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    async getContinuousStations({ commit }) {
      try {
        let url = BASE_URL_getStations
        let res = await axios.get(url)
        commit(SET_CONTINUOUS_STATIONS, res.data)
      } catch (error) {
        console.error(error)
      }
    },
    async getContinuousTimeSeries({ commit }) {
      try {
        let url = BASE_URL_getTimeSeries
        let res = await axios.get(url)
        commit(SET_CONTINUOUS_TIMESERIES, res.data)
      } catch (error) {
        console.error(error)
        //options.failedCb(error.response.data.ExceptionMessage)
      }
    },
    async getImporterList({ commit }) {
      try {
        let url = BASE_URL_getImporterList
        let res = await axios.get(url)
        commit(SET_IMPORTER_CONFIGS, res.data)
      } catch (error) {
        console.error(error)
      }
    },
    async getImporterDetail({ commit }, options) {
      try {
        let url = BASE_URL_Importer + '/' + options.data
        let res = await axios.get(url)
        commit(SET_IMPORTER_CONFIG_Detail, res.data)
        return res.data
      } catch (error) {
        console.error(error)
      }
    },
    async addImporterConfig({ commit }, options) {
      try {
        let url = BASE_URL_Importer
        let res = await axios.post(url, options.data)
        let importer = {
          Id: res.data.Id,
          Name: res.data.Name,
          ImporterType: res.data.ImporterType,
          Description: res.data.Description,
          ExecuteInterval: res.data.ExecuteInterval,
        }
        commit(ADD_IMPORTER_CONFIG, importer)
        options.successCb()
      } catch (error) {
        console.error(error)
        options.failedCb(error.response.data.ExceptionMessage)
      }
    },
    async updateImporterConfig({ commit }, options) {
      try {
        let url = BASE_URL_Importer
        let res = await axios.put(url, options.data)
        let importer = {
          Id: res.data.Id,
          Name: res.data.Name,
          ImporterType: res.data.ImporterType,
          Description: res.data.Description,
          ExecuteInterval: res.data.ExecuteInterval,
        }
        commit(UPDATE_IMPORTER_CONFIG, importer)
        options.successCb()
      } catch (error) {
        console.error(error)
        options.failedCb(error.response.data.ExceptionMessage)
      }
    },
    getImporterLogs({ commit }, options) {
      let url = BASE_URL_getImporterLogs
      return axios.post(url, options)
        .then((res) => commit(SET_IMPORTER_LOGS, res.data))
        .catch((error) => {
          console.error(error.response.data.ExceptionMessage)
          throw error.response.data.ExceptionMessage
        })
    },
    delteImporterConfig({ commit }, options) {
      let url = BASE_URL_delteImporterConfig + options
      return axios.delete(url)
        .then(() => commit(DELETE_IMPORTER, options))
        .catch((error) => {
          console.error(error)
          throw error
        })
    },
  },

  mutations: {
    [SET_CONTINUOUS_STATIONS](state, data) {
      state.Stations = data.sort((a, b) => (a.StationName > b.StationName ? 1 : -1))
    },
    [SET_CONTINUOUS_TIMESERIES](state, data) {
      state.TimeSeries = data
      let stationGroupNG = {}
      let listNG = data.filter(x => x.AquariusServer === AQUARIUS_SERVER_NG)
      listNG.forEach(element => {
        let stationName = extractStationNameFromDatasetName(element.TimeSeriesName)
        if (stationName in stationGroupNG) {
          stationGroupNG[stationName].push(element)
        } else {
          stationGroupNG[stationName] = [element]
        }
      })
      let selectListNG = []
      Object.keys(stationGroupNG).forEach(element => {
        selectListNG.push({ divider: true })
        selectListNG.push({ header: element })
        selectListNG.push(...stationGroupNG[element])
      })
      state.NGTimeSeriesReady = true
      state.NGTimeSeriesList = selectListNG
    },
    [SET_IMPORTER_CONFIGS](state, data) {
      state.ImporterConfigs = data
    },
    [SET_IMPORTER_CONFIG_Detail](state, data) {
      state.ImporterConfigDetail = data
    },
    [ADD_IMPORTER_CONFIG](state, data) {
      state.ImporterConfigs.push(data)
    },
    [UPDATE_IMPORTER_CONFIG](state, data) {
      let dc = JSON.parse(JSON.stringify(state.ImporterConfigs))
      let ImporterConfig = dc.find(x => x.Id == data.Id)
      let i = dc.indexOf(ImporterConfig)
      dc.splice(i, 1, data)
      state.ImporterConfigs = dc
    },
    [SET_IMPORTER_LOGS](state, data) {
      state.ImportersLogs = data
    },
    [DELETE_IMPORTER](state, data) {
      let dc = JSON.parse(JSON.stringify(state.ImporterConfigs))
      let ImporterConfig = dc.find(x => x.Id == data)
      let i = dc.indexOf(ImporterConfig)
      state.ImporterConfigs.splice(i, 1)
    },
  },

  getters: {
    NGStations: state => state.Stations.filter(x => x.AquariusServer === AQUARIUS_SERVER_NG),
    TimeSeries: state => state.TimeSeries,
    TimeSeriesReady: state => state.NGTimeSeriesReady,    
    NGTimeSeriesList: state => state.NGTimeSeriesList,
    AQUARIUS_SERVER_NG: () => AQUARIUS_SERVER_NG,
    Stations: state => state.Stations,
    ImporterConfigs: state => state.ImporterConfigs,
    ImporterConfigDetail: state => state.ImporterConfigDetail,
    ImportersLogs: state => state.ImportersLogs,
    IMPORTER_TYPE_GOES: () => IMPORTER_TYPE_GOES,
    IMPORTER_TYPE_SIMPLE_SUTRON: () => IMPORTER_TYPE_SIMPLE_SUTRON,
    IMPORTER_TYPE_JDS: () => IMPORTER_TYPE_JDS,
    IMPORTER_TYPE_Optimum: () => IMPORTER_TYPE_Optimum,
  },
}